const isYearly = (interval: string): boolean => interval === 'year';

export default isYearly;
